import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Plot } from '@abaco/portal-global-state/src/modules/global-state/models/Plot';
import { Block } from "@abaco/crop-plan-module/src/modules/crop-plan-module/models/Block";
import { Agreement, AgreementType, FormAttachments, FormSection, MainAgreementData } from "./models/NewAgreementsModel";
import { Movement } from "./models/MovementModel";
export default class NewAgreementsVuexModule extends AbacoVuexModule {

    @State() isProtocol!: boolean;

    @State({ default: [] }) selectedPlots!: Plot[];
    @State({ default: [] }) selectedBlocks!: Block[];

    @State( {default: false}) isRedirectedFromWidget!: boolean;

    @State() backToModule!: string | null;

    @State() selectedAgreementType!: AgreementType | null;      //Agreement type selected (first step)
    @State() mainAgreementData!: MainAgreementData | null;      //Agreement main data (second step)
    @State() curAgreement!: Agreement | null;                   //Selected agreement
    @State() editingAgreement!: boolean;
    @State() editingParties!: boolean;
    @State({default: []}) STORE_agreementsMovements!: Movement[];

    @State() formSections!: FormSection | null;
    @State({default: []}) formAttachments!: FormAttachments[];
    @State() isSaved!: boolean;
    @State() completeFormSections!: FormSection | null;
    @State({default: false}) agreementEditAuth!: boolean;
}
